import React from 'react';
import xr from 'xr';
import { createGlobalStyle } from 'styled-components';
import { setup, renderScreens, screen } from './dooh-react-utils';
import { getAppInfo } from 'dooh-utils';
import { preloader } from './img';

setup('https://interaktivno.go2digital.hr/').then(async data => {
  const state = {
    screen: 'intro',
    pic: 5,
    time: 12402,
    name: 'Ivan Ivanić',
    topList: [],
    topListOnline: [],
    style: null,
  };

  const store = await renderScreens(
    [
      screen(require('./screens/Intro').default, 'intro', {}),
      screen(require('./screens/Game').default, 'game', {}),
      screen(require('./screens/Result').default, 'result', {
        timeout: 15 * 1000,
      }),
      screen(require('./screens/Form').default, 'form', { timeout: 120 * 1000 }),
      screen(require('./screens/Thanks').default, 'thanks', {
        timeout: 5 * 1000,
      }),
    ],
    state,
    s => s.screen,
    preloader
  );

  const Style = createGlobalStyle`
    body {
      background: #d8dede;
    }

    #root {
      font-family: 'boldfont', sans-serif;
      color: white;
    }
  `;

  store.update({
    style: <Style />,
  });

  updateTopList(store.update);
  setInterval(() => updateTopList(store.update), 1000 * 60);
});

export async function updateTopList(update) {
  const { instance, tracking } = getAppInfo();
  if (tracking && instance) {
    const { data } = await xr.get(
      `https://interaktivno.go2digital.hr/api/games/results/?game_instance=${instance}&page_size=10&tracking=${tracking}`
    );
    update({ topListOnline: data.results });
  }
}
